module.exports = __webpack_public_path__ + "img/pakiet_3.03498ad8.svg";